<div >
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row" style="margin:0px;padding:0px;">
    <div class="col-12" style="margin:0px;padding:0px;">
      <div class="prx-nav" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;display:none">
        <ul class="nav nav-pills nav-tabs nav-fill" role="tablist" style="margin:0px;padding:0px;">
          <!-- <li class="nav-item tb-siz">
            <a class="nav-link text-left" [ngClass]="{ 'active':utility.activeTab==1}" data-toggle="tab" href="#car-info" (click)="onActive1(1)" >
              <span class="row">
                <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==1" src="/assets/Trafficlight.png"  />Step 1: Permit Type</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz" >
            <a class="nav-link" data-toggle="tab" href="#car-doc" (click)="onActive1(2)" [ngClass]="{ 'active':utility.activeTab==2}">
              <span class="row" >
                <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==2" src="/assets/Trafficlight.png"  />Step 2: Vehicles</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-conf" (click)="onActive1(3)" [ngClass]="{ 'active':utility.activeTab==3}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==3" src="/assets/Trafficlight.png"/>&nbsp; Step 3: Routes</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-conf" (click)="onActive1(4)" [ngClass]="{ 'active':utility.activeTab==4}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==4" src="/assets/Trafficlight.png"  />&nbsp; Step 4: Motivation</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-conf" (click)="onActive1(5)" [ngClass]="{ 'active':utility.activeTab==5}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==5" src="/assets/Trafficlight.png"  />&nbsp; Step 5: Uploads</span>
              </span>
            </a>
          </li>
          <li class="nav-item tb-siz">
            <a class="nav-link" data-toggle="tab" href="#car-conf" (click)="onActive1(6)" [ngClass]="{ 'active':utility.activeTab==6}">
              <span class="row" style="margin:0px;padding:0px;margin-top: auto;margin-bottom: auto;">
              <span  class="col-12 centrer tab-hd"><img *ngIf="utility.activeTab==6" src="/assets/Trafficlight.png"  />&nbsp; Step 6: Confirmation</span>
              </span>
            </a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="col-12" style="margin:0px">
      <div class="tab-content" style="margin-top:5px;width:100%;">
        <!-- <div class="container-fluid">
          <div class="row" style="margin:0px;padding:0px;">
            <div class="col-12" style="margin:0px;padding:0px;">
              <div class="btn-group btn-style" dropdown>
                <button id="button-basic" (click)="showMenu('dropdown-basic')"  type="button" class="btn btn-primary dropdown-toggle"
                        aria-controls="dropdown-basic">
                  Select Actions <span class="caret"></span>
                </button>
                <ul id="dropdown-basic" *ngIf="showMenuBtn" class="dropdown-menu dropdown-list" style="display:block"
                    role="menu" aria-labelledby="button-basic">
                  <li role="menuitem"><a class="dropdown-item" (click)="cancel()" href="javascript:void(0)">Cancel</a></li>
                  <li role="menuitem"><a class="dropdown-item"  [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Additional Info</a></li>
                  <li role="menuitem"><a class="dropdown-item" [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Approve</a></li>
          
                  <li role="menuitem"><a class="dropdown-item"  [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Escalate</a>
                  </li>
                  <li role="menuitem"><a class="dropdown-item"  [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Update</a>
                  </li>
                  <li role="menuitem"><a class="dropdown-item"  [routerLink]="['/permit/approval/correspondence',dataCntrl.application.id]" href="javascript:void(0)">Change Status</a>
                  </li>
                </ul>
              </div>
        
              </div>
            </div>
          </div> -->
        <!-- <div class="tab-pane mk-frm" id="car-info" [ngClass]="{ 'active':utility.activeTab==1}" >
          <div class="row">
            <div class="col-12 mk-space" *ngIf="utility.activeTab==1">
              <permit-type-viewer  [(ctrlData)]="ctrlData"></permit-type-viewer>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-doc" [ngClass]="{ 'active':utility.activeTab==2}">
          <div class="row">
            <div class="col-12" style="margin-top:20px!important;" *ngIf="utility.activeTab==2">
              <vehicle-viewer  [(ctrlData)]="ctrlData"></vehicle-viewer>
            </div>

          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" [ngClass]="{ 'active':utility.activeTab==3}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="utility.activeTab==3">

              <route-viewer [(ctrlData)]="ctrlData"></route-viewer>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" [ngClass]="{ 'active':utility.activeTab==4}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="utility.activeTab==4">
              <motivation-viewer  [(ctrlData)]="ctrlData"></motivation-viewer>
            </div>
          </div>
        </div>
        <div class="tab-pane mk-frm" id="car-conf" [ngClass]="{ 'active':utility.activeTab==5}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="utility.activeTab==5">
              <uploads-viewer  [(ctrlData)]="ctrlData"></uploads-viewer>
            </div>
          </div>
        </div> -->
        <div class="tab-pane mk-frm" id="car-conf" [ngClass]="{ 'active':utility.activeTab==1}">
          <div class="row" style="margin-top:20px!important;">
            <div class="col-12" *ngIf="showPage">        
              <confirmation-viewer   [dataCntrl]="dataCntrl"></confirmation-viewer>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- <button
        class="btn btn-md m-clr pull-right hd-btn"  style="float: right !important;" (click)="onActive(2)">
        <i class="fa fa-save" ></i> Save & Continue</button> -->
</div>
